import { useContext, useRef } from "react";
import searchContext from "../../../dataManager/context/searchContext";

/**
 * input to seach with keyword
 * @param {string} value
 * @param {() => {}} onChangeValue
 * @param {string} type
 * @param {string} placeholder
 * @param {string} classe
 * @returns
 */
const SearchInput = ({
  value,
  onChangeValue,
  type,
  placeholder,
  inputRef,
  classe,
}) => {
  //context variables
  const { showMobileSearchInput } = useContext(searchContext);

  return (
    <div className="relative h-10 w-full  items-center bg-secondary md:block">
      <input
        ref={inputRef}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChangeValue(e.target.value)}
        className={`${classe} ${
          showMobileSearchInput
            ? "outline-none focus:outline-none"
            : "focus:outline focus:outline-primary"
        } searchInput  block h-full  bg-[#2C3850] p-2 text-sm text-white/50 caret-primary placeholder:text-sm placeholder:italic   md:p-4`}
      />
    </div>
  );
};

export default SearchInput;
